export default __webpack_public_path__ + "static/media/Dmitri-Particle_0002_IceSpike1.f73273e9.png";